import React from "react";

export interface KunaiProps {
  width?: number;
  height?: number;
  color?: string;
}

const Kunai: React.FC<KunaiProps> = ({ width = 20, height = 20, color = "#ffffff" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.34317 0.633099C7.6761 -0.211047 8.87078 -0.211046 9.2037 0.633099L10.9425 5.04193C11.0442 5.29965 11.2482 5.50366 11.5059 5.6053L15.9147 7.34412C16.7589 7.67705 16.7589 8.87172 15.9147 9.20465L11.5059 10.9435C11.2482 11.0451 11.0442 11.2491 10.9425 11.5068L9.2037 15.9157C8.87078 16.7598 7.6761 16.7598 7.34317 15.9157L5.60436 11.5068C5.50271 11.2491 5.29871 11.0451 5.04098 10.9435L0.632153 9.20465C-0.211993 8.87172 -0.211993 7.67705 0.632153 7.34412L5.04098 5.6053C5.29871 5.50366 5.50271 5.29965 5.60436 5.04193L7.34317 0.633099Z"
        fill={color}
      />
    </svg>
  );
};

export default Kunai;
